import React from 'react';
import { FetchSessionsQueryVariables } from '../../../../typescript/generated/codegen';
import Classifications from './classifications';
import FiltersSideModal from './sideModal/filtersSideModal';
import SortBy from './sortBy';

interface FiltersProps {
  classifications: string[];
  filters: FetchSessionsQueryVariables;
  setFilters: (filters: FetchSessionsQueryVariables) => void;
}

const Filters: React.FC<FiltersProps> = ({
  classifications,
  filters,
  setFilters,
}) => {
  return (
    <>
      {/* MOBILE VIEW */}
      <div className="md:hidden">
        <Classifications
          classifications={classifications}
          filters={filters}
          setFilters={setFilters}
        />
        <div className="flex flex-row items-center justify-between pt-16px">
          <SortBy filters={filters} setFilters={setFilters} side="right" />

          <FiltersSideModal
            initialFilters={filters}
            onConfirm={setFilters}
            classifications={classifications}
          />
        </div>
      </div>

      {/* TABLET & DESKTOP VIEW */}
      <div className="hidden md:flex flex-row items-center justify-between font-family-semibold text-sm">
        <div className="flex flex-row items-center space-x-16px">
          <Classifications
            classifications={classifications}
            filters={filters}
            setFilters={setFilters}
          />
          <FiltersSideModal
            initialFilters={filters}
            onConfirm={setFilters}
            classifications={classifications}
          />
        </div>

        <SortBy filters={filters} setFilters={setFilters} side="left" />
      </div>
    </>
  );
};

export default Filters;
